export default "__VITE_ASSET__6b40cfce__"